/**
 * @Author: zpc
 * @Description:
 * @DateTime: Created in 2023-05-08 13:21:00
 */

 import {Component} from 'vue-property-decorator'
 import BasicSearchPage from "src/components/basicSearchPage/basicSearchPage";
 import override from "src/dectorators/override";
 import {FeedbackOpinionDOI} from "./api/feedbackOpinionApi";
 import FeedbackOpinionService from "./service/feedbackOpinionService";
 import './feedbackOpinion.less';
 
 @Component({name: 'feedback-opinion'})
 export default class FeedbackOpinion extends BasicSearchPage<FeedbackOpinionService, FeedbackOpinionDOI.RowDataI, FeedbackOpinionDOI.QueryRowDataParamsI> {
 
     @override
     renderHead(h) {
        return <div></div>
     }
     
     @override
     loadService () {
         this.service = new FeedbackOpinionService(this)
     }
 }